import { DEAL_TYPES, PROMO_CODE_TYPES } from '../../../../../services/exports/Constants';

export default {
  title: 'Speziale Angebote',
  deals: {
    [DEAL_TYPES.GOOGLE_REVIEW_PROGRAM]: {
      title: '+{{reward}} Extra Punkte',
      description: 'Bewerte uns auf Google',
    },
    [DEAL_TYPES.SMART_PRICING_RULE]: {
      description: 'Bereits automatisch angewandt',
    },
    buttons: {
      add: 'Hinzufügen',
      remove: 'Entfernen',
      show_details: 'Details anzeigen',
    },
    mobile_app_signup_bonus: {
      title: '{{amount}} AppAnmelde-Bonus',
      desc: 'Erhalte {{amount}} Cashback, wenn du dich in unserer App anmeldest.',
    },
  },
  discounts: {
    title: '{{discount}} Rabatt',
    description: {
      [PROMO_CODE_TYPES.ONE_TIME_PROMO_CODE]: '{{discount}} Rabatt auf deine nächste Bestellung - Code: {{code}}',
      [PROMO_CODE_TYPES.MULTI_PROMO_CODE]:
        '{{discount}} Rabatt auf deine nächsten {{count}} Bestellungen - Code: {{code}}',
    },
  },
  feedback: {
    login:
      '<highlight>Log dich ein,</highlight> um diese Promo zu nutzen, damit wir sicherstellen, dass du sie noch nicht aufgebraucht hast. Login und versuche es erneut.',
  },
};
